import { useEffect } from "react";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { Addons } from "./Addons";
import { BillingProvider } from "./BillingContext";
import { Cancellation } from "./Cancellation";
import { EmailHubBanner } from "./EmailHubBanner";
import { PlanDetails } from "./PlanDetails";
import { UpcomingInvoice } from "./UpcomingInvoice";
import { UsageDetails } from "./UsageDetails";

interface NewBillingDetailsProps {
  showAddons?: boolean;
  showBillingDetails?: boolean;
  showBillingPortal?: boolean;
}

export const NewBillingDetails = ({
  showAddons,
  showBillingDetails,
  showBillingPortal,
}: NewBillingDetailsProps) => {
  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("plan_settings.billing_page.visited", {});
  }, []);

  return (
    <BillingProvider
      showAddons={showAddons}
      showBillingDetails={showBillingDetails}
      showBillingPortal={showBillingPortal}
    >
      <div className="my-12">
        <div className="flex flex-row gap-x-6">
          <div className="flex w-[680px] flex-col gap-y-6">
            <PlanDetails />
            <Addons />
            <UsageDetails />
            <EmailHubBanner />
            <Cancellation />
          </div>
          <div className="w-[375px]">
            <UpcomingInvoice />
          </div>
        </div>
      </div>
    </BillingProvider>
  );
};
